import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/new/chatId/page';

export const Route = createFileRoute('/_app/_chat/skills/new/$chatId/')({
  component: Page,
});
